import { Component } from '@angular/core';

@Component({
  selector: 'lib-usermgmt',
  imports: [],
  template: `
    <p>
      usermgmt works!
    </p>
  `,
  styles: ``
})
export class UsermgmtComponent {

}
